/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Group_AppInputs */

const en_settings_group_app = /** @type {(inputs: Settings_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App`)
};

const de_settings_group_app = /** @type {(inputs: Settings_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App`)
};

/**
* | output |
* | --- |
* | "App" |
*
* @param {Settings_Group_AppInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_group_app = /** @type {((inputs?: Settings_Group_AppInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Group_AppInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_group_app(inputs)
	return en_settings_group_app(inputs)
});